var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNorthWest(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.033 53.033C62.7961 43.2699 62.7961 27.4408 53.033 17.6777C43.2699 7.91457 27.4408 7.91457 17.6777 17.6777C7.91456 27.4408 7.91456 43.2699 17.6777 53.033C27.4408 62.7961 43.2699 62.7961 53.033 53.033Z",
    fill: "#1a76d2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3617 25.9941L32.4656 47.3059C32.6054 47.7254 33.1809 47.7702 33.3841 47.3775L37.9353 38.5784C38.0779 38.3026 38.3027 38.0779 38.5785 37.9352L47.3775 33.384C47.7703 33.1809 47.7254 32.6054 47.3059 32.4656L25.9941 25.3616C25.6032 25.2313 25.2314 25.6032 25.3617 25.9941Z",
    fill: "white",
    stroke: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNorthWest);
export default __webpack_public_path__ + "static/media/north-west.ee70df3d79db15aa59035f366511e42b.svg";
export { ForwardRef as ReactComponent };